<script>
import dateMixin from "@/mixins/dateMixin";

import CustomDialog from "@/components/_Shared/Dialog";

export default {
  mixins: [dateMixin],

  props: {
    visible: {
      type: Boolean,
      required: false,
      default: false
    },
    date: {
      type: Date,
      required: true
    }
  },

  components: {
    CustomDialog
  }
};
</script>

<template>
  <custom-dialog
    :visible="visible"
    icon="/static/icon-alert-purple.svg"
    title="Confirme para finalizar seu pedido"
  >
    <template slot="body">
      <p>
        Você escolheu o dia <b>{{date | formatDate("DD/MM/Y")}}</b>, neste dia
        haverá suporte do time de atendimento, mas em horário reduzido!
      </p>
      <p>
        Em casos de <b>Imprevistos</b>, <b>reagendamentos</b> ou
        <b>cancelamentos</b> nesse dia, tentaremos resolver o seu ticket de
        atendimento no mesmo dia ou no <b>próximo dia útil</b>. Você está
        ciente e deseja prosseguir?
      </p>
      <hr />
      <p>Nosso atendimento é de segunda à sexta das 8h às 18h e aos sábado das 8h às 14h.</p>

      <div class="btn-group">
        <div class="btn bg-purple-outline" @click="$emit('reject')">Não, desejo escolher outra data</div>
        <div class="btn bg-purple" @click="$emit('accept')">Sim, estou ciente</div>
      </div>
    </template>
  </custom-dialog>
</template>

<style scoped>
hr {
  width: 50px;
  background-color: transparent;
  border: 1px solid var(--purple);
  border-bottom: none;
  opacity: 0.5;
}
</style>



// WEBPACK FOOTER //
// src/components/_Shared/Warnings/WontHaveInstantSupport.vue